import Autocomplete from "../modules/Autocomplete";
import WorkplaceService from "../services/WorkplaceService";

export default class WorkplaceAutocomplete extends HTMLInputElement {

    connectedCallback() {

        const options = {
            valueTarget: document.querySelector(`#${this.dataset.valueTarget}`),
            valueKey: "id",
            textKey: "name",
            query: function (value) {
                const service = new WorkplaceService();
                return service.query(value);
            }
        }

        this._autocomplete = new Autocomplete(this, options);
        
    }

    disconnectedCallback() {

        //this._autocomplete.destroy();

    }

}

customElements.define("workplace-autocomplete", WorkplaceAutocomplete, { extends: "input" });